
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const SecurityWarning = () => {
  return (
    <div className="bg-red-900/30 border-2 border-red-500 p-6 rounded-lg">
      <div className="flex items-start space-x-4">
        <AlertTriangle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" />
        <div className="text-red-200">
          <h3 className="text-xl font-bold mb-2">🚨 CRITICAL: Save Your Account Information</h3>
          <p className="text-sm leading-relaxed">
            Save your <strong>username, password, PIN, and recovery phrase</strong> immediately. 
            This is the <strong>ONLY</strong> time you'll see your password in plain text. 
            Store all information safely and never share it with anyone.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityWarning;
